import(/* webpackMode: "eager" */ "/Users/zrzz/Coding/openpaper/client/src/app/(main)/login/page.tsx");
